import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { AdminState } from './state';

const defaultState: AdminState = {
  users: [],
  templates: { total: 0, items: [] },
  contracts: [],
  services: [],
  proxyErrors: [],
  senders: [],
  priorities: [],
  mnos: [],
  tags: [],
  mnoMasks: [],
  mnoSenders: [],
  serviceBanPolicies: [],
  checkMNOMaskResponse: null,
};

export const adminModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
